import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Layout from 'components/Layout/Layout';
import Tab from './Tab';
import * as Styled from './TabLayout.styles';
var TabLayout = function (_a) {
    var children = _a.children, tabList = _a.tabList, defaultTabLabel = _a.defaultTabLabel, onClick = _a.onClick;
    return (_jsx(Styled.Container, { children: _jsx(Layout, { children: _jsxs(Styled.TabContainer, { children: [_jsx(Tab, { tabList: tabList, defaultTabLabel: defaultTabLabel, onClick: onClick }, void 0), _jsx(Styled.Content, { children: children }, void 0)] }, void 0) }, void 0) }, void 0));
};
export default TabLayout;
